import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

var _excluded = ["align", "inline"];
var IconBlacklisted = function IconBlacklisted(_ref) {
  var align = _ref.align,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    props = _objectWithoutProperties(_ref, _excluded);
  var className = classnames('tds-icon', _defineProperty({
    'tds-icon--inline': inline
  }, "tds-icon--".concat(align), align), 'tds-icon-blacklisted', props.className);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    className: className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "#ED4E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 16.5L16.5996 7.5",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};
IconBlacklisted.propTypes = {
  className: PropTypes.string.isRequired,
  align: PropTypes.bool.isRequired,
  inline: PropTypes.bool.isRequired
};

export { IconBlacklisted as default };
